import { Injectable } from '@angular/core';
import {HttpObservable} from '../../common/http-helpers/http.wrapper';
import {LogoutReason} from "../common/common.types";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {share} from "rxjs/operators";
import {AppConfigurationService} from "../../common/app-config/app-configuration.service";

@Injectable({
  providedIn: 'root'
})
export class AuthProviderProxy {

  constructor(private httpClient: HttpClient,
              private configService: AppConfigurationService) { }

  public logout(reason: LogoutReason, accessToken: string): HttpObservable<void> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.set("Authorization", "Bearer " + accessToken);

    return this.httpClient.request('POST',
              this.configService.Config.WebApiUrl + '/PatientPortalLogout/Logout',
              { body: reason, headers});
  }
}
